import { Link } from "react-router-dom";
import { Target, Eye, ShieldCheck, Users, Send } from "lucide-react";
import Layout from "@/components/Layout";
import Seo from "@/components/Seo";
import { useSettings } from "@/context/SettingsContext";

const VALUES = [
  {
    icon: Target,
    title: "Хиперлокален фокус",
    text: "Пишем само за район Подуяне — новини, които наистина засягат ежедневието на жителите на квартала.",
  },
  {
    icon: ShieldCheck,
    title: "Независимост",
    text: "Частна и независима медия. Не сме официален канал на общината или районната администрация.",
  },
  {
    icon: Users,
    title: "Гражданско участие",
    text: "Всеки жител може да подаде сигнал за проблем. Заедно държим квартала под око.",
  },
  {
    icon: Eye,
    title: "Прозрачност",
    text: "Проверяваме фактите и показваме реалната картина — за ремонти, трафик, инциденти и сигнали.",
  },
];

export default function About() {
  const settings = useSettings();
  return (
    <Layout showTicker={false}>
      <Seo
        title="За нас"
        description="Кои сме ние — „Подуяне Днес“ е независима хиперлокална медия за район Подуяне, София."
      />
      <div className="mx-auto max-w-4xl px-4 py-12 sm:px-6 lg:px-8" data-testid="about-page">
        <span className="inline-flex rounded-full bg-primary/10 px-3 py-1 text-xs font-bold uppercase tracking-wide text-primary">
          За нас
        </span>
        <h1 className="mt-4 font-display text-4xl font-extrabold leading-tight text-slate-900">
          Гласът на квартал Подуяне
        </h1>
        <p className="mt-4 max-w-2xl text-lg leading-relaxed text-slate-600">
          {settings.about_text}
        </p>

        <div className="mt-10 grid gap-5 sm:grid-cols-2">
          {VALUES.map((v) => (
            <div
              key={v.title}
              className="rounded-xl border border-slate-200 bg-white p-6"
            >
              <div className="flex h-11 w-11 items-center justify-center rounded-lg bg-primary/10">
                <v.icon className="h-6 w-6 text-primary" />
              </div>
              <h3 className="mt-4 font-display text-lg font-bold text-slate-900">
                {v.title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-slate-600">{v.text}</p>
            </div>
          ))}
        </div>

        <div className="mt-12 rounded-2xl bg-slate-900 p-8 text-center text-white sm:p-10">
          <h2 className="font-display text-2xl font-extrabold">
            Станете част от историята на квартала
          </h2>
          <p className="mx-auto mt-3 max-w-lg text-slate-300">
            Видяхте нещо важно? Вашият сигнал може да стане следващата новина.
          </p>
          <Link
            to="/izprati-signal"
            className="mt-6 inline-flex items-center gap-2 rounded-full bg-primary px-6 py-3 text-sm font-bold text-white hover:bg-[#0041A8]"
          >
            <Send className="h-4 w-4" />
            Изпрати сигнал
          </Link>
        </div>
      </div>
    </Layout>
  );
}
